/**
 *
 * @param {Object} state
 * @param {Object} product
 */
const SET_APP_PRODUCT_ID = (state, product) => {
  let appProduct = state.appProduct;
  product.entity_id ? (appProduct.id = product.entity_id) : false;
};

/**
 *
 * @param {Object} state
 * @param {Object} product
 */
const SET_APP_PRODUCT_ID_FROM_CART = (state, product) => {
  let appProduct = state.appProduct;
  product.productId ? (appProduct.id = product.productId) : false;
};

/**
 *
 * @param {Object} state
 * @param {Object} product
 */
const SET_APP_PRODUCT_CART_URL = (state, product) => {
  let appProduct = state.appProduct;
  product.cart_url ? (appProduct.cartUrl = product.cart_url) : false;
};

/**
 *
 * @param {Object} state
 * @param {Object} product
 */
const SET_APP_PRODUCT_GLOBALS = (state, product) => {
  let appProduct = state.appProduct;
  product.name ? (appProduct.name = product.name) : false;
  product.sku ? (appProduct.sku = product.sku) : false;
  product.short_description ? (appProduct.shortDescription = product.short_description) : false;
  product.ba_refconstructeur ? (appProduct.baRefConstructeur = product.ba_refconstructeur) : false;
  product.mcp_manufacturer_reference
    ? (appProduct.baRefConstructeur = product.mcp_manufacturer_reference)
    : false;
};

/**
 *
 * @param {Object} state
 * @param {Object} product
 */
const SET_APP_PRODUCT_DESCRIPTIONS = (state, product) => {
  let appProduct = state.appProduct;
  product.technical_characteristics
    ? (appProduct.technicalCharacteristics = product.technical_characteristics)
    : false;
  product.description ? (appProduct.description = product.description) : false;
};

/**
 *
 * @param {Object} state
 * @param {Object} product
 */
const SET_APP_PRODUCT_THUMBNAIL = (state, product) => {
  let appProduct = state.appProduct;
  product.small_image ? (appProduct.thumbnail = product.small_image) : false;
};

/**
 *
 * @param {Object} state
 * @param {Object} product
 */
const SET_APP_PRODUCT_LEGEND = (state, product) => {
  state.appProduct.legend.dimensions = product.dimensions;
  state.appProduct.legend.icon = product.dimensions_icon;
  state.appProduct.legend.title = product.dimensions_wording;
  product.short_description
    ? (state.appProduct.legend.shortDescription = product.short_description)
    : false;
  product.name ? (state.appProduct.legend.name = product.name) : false;
};

/**
 *
 * @param {Object} state
 * @param {Object} product
 */
const SET_APP_PRODUCT_GALLERY = (state, product) => {
  product.media_gallery ? (state.appProduct.gallery.images = product.media_gallery) : false;
  product.pictos ? (state.appProduct.gallery.pictos = product.pictos) : false;
  product.energy_label ? (state.appProduct.gallery.energyLabel = product.energy_label) : false;
  product.entity_id ? (state.appProduct.gallery.productId = product.entity_id) : false;
  product.brand_image ? (state.appProduct.gallery.brandImage = product.brand_image) : false;
};

/**
 *
 * @param {Object} state
 * @param {Object} product
 */
const SET_APP_PRODUCT_VIDEO = (state, product) => {
  product.ba_video_1 ? (state.appProduct.videos[0] = product.ba_video_1) : false;
  product.ba_video_2 ? (state.appProduct.videos[1] = product.ba_video_2) : false;
  product.mcp_video_1 ? (state.appProduct.videos[0] = product.mcp_video_1) : false;
  product.mcp_video_2 ? (state.appProduct.videos[1] = product.mcp_video_2) : false;
};

/**
 *
 * @param {Object} state
 * @param {Object} product
 */
const SET_APP_PRODUCT_SHIPPING_METHODS = (state, product) => {
  product.shipping_methods ? (state.appProduct.shippingMethods = product.shipping_methods) : false;
};

/**
 *
 * @param {Object} state
 * @param {Object} product
 */
const SET_APP_PRODUCT_OPTIONS = (state, product) => {
  product.options ? (state.appProduct.options = product.options) : false;
};

/**
 *
 * @param {Object} state
 * @param {Object} product
 */
const SET_APP_PRODUCT_NOTICE = (state, product) => {
  product.notice ? (state.appProduct.notice = product.notice) : false;
  product.notice_count ? (state.appProduct.noticeCount = product.notice_count) : false;
};

/**
 *
 * @param {Object} state
 * @param {Object} product
 */
const SET_APP_PRODUCT_IS_IN_COMPARATOR = (state, product) => {
  product.is_in_comparator ? (state.appProduct.isInComparator = product.is_in_comparator) : false;
};

/**
 *
 * @param {Object} state
 * @param {Object} product
 */
const SET_APP_PRODUCT_FLASH_SELL = (state, product) => {
  let flashSell = state.appProduct.flashSell;

  product.privatesale_date_start
    ? (flashSell.startFlashSell = product.privatesale_date_start)
    : false;
  product.privatesale_date_end ? (flashSell.endFlashSell = product.privatesale_date_end) : false;
};

const SET_APP_PRODUCT_ESSENTIALS_OPTIONS = (state, product) => {
  product.essentials_options ? (state.appProduct.essentialsOptions = product.essentials_options) : false;
};

/**
 *
 * @param {Object} state
 * @param {Object} product
 */
const SET_APP_PRODUCT_SHIPPING_INFO = (state, product) => {
  let shippingInfo = state.appProduct.shippingInfo;

  // AVAILABLE STATUS
  shippingInfo.available = (product.is_in_stock && product.is_in_stock != "0") ? true : false;

  // PRODUCT PRICES
  product.prices.final_price
    ? (shippingInfo.prices.finalPrice = product.prices.final_price)
    : false;
  product.prices.price ? (shippingInfo.prices.price = product.prices.price) : false;

  // ALSO EXIST
  let array = {
    id: product.entity_id,
    label: product.ba_capacity || product.mcp_model_product || product.pac_model_product,
  };
  product.also_exists.unshift(array);
  product.also_exists ? (shippingInfo.existAlso = product.also_exists) : false;

  if (product.display_stock_availability !== undefined) {
    shippingInfo.displayStockAvailability = product.display_stock_availability;
  }
};

/**
 *
 * @param {Object} state
 * @param {Object} product
 */
const SET_APP_PRODUCT_SHIPPING_METHOD_SPECIAL_PRICE = (state, specialPrice) => {
  
  state.appProduct.billInfo.currentShippingMethodPrice.specialPrice = specialPrice
}

/**
 *
 * @param {Object} state
 * @param {String} selectedMethods
 */
const SET_APP_PRODUCT_BILL_INFO = (state, selectedMethods) => {
  let billInfo = state.appProduct.billInfo;
  let shippingMethods = state.appProduct.shippingMethods[selectedMethods].total_price;
  let relatedProducts = state.appProduct.shippingMethods[selectedMethods].related_product; // Shipping Method Related Product
  billInfo.schedule = shippingMethods.schedule;

  // ECOTAX
  shippingMethods.ecotax ? (billInfo.ecoTaxe = shippingMethods.ecotax) : false;
  localStorage.setItem("ecoTaxe", shippingMethods.ecotax);
  // TVA
  if (shippingMethods.main_product_tax_percent) {
    billInfo.tva = shippingMethods.main_product_tax_percent;
    billInfo.originalTva = shippingMethods.main_product_tax_percent;
  }
  // PRICE
  shippingMethods.price ? (billInfo.originalPrice = shippingMethods.price) : false;
  shippingMethods.final_price && shippingMethods.final_price !== shippingMethods.price
    ? (billInfo.specialPrice = shippingMethods.final_price)
    : false;

  relatedProducts !== "" ? (state.appProduct.relatedProducts = relatedProducts) : state.appProduct.relatedProducts = false;
};

const SET_APP_PRODUCT_REDUCED_TAX_RATE = (state, product) => {
  product.reduced_tax_rate ? (state.appProduct.reducedTaxRate = product.reduced_tax_rate) : false;
};

// --- RELATED

/**
 *
 * @param {Object} state
 * @param {Object} relatedProduct
 */
const SET_APP_PRODUCT_RELATED = (state, product) => {
  product.related_products ? (state.appProduct.productsRelated = product.similar_products) : false;
};

/**
 *
 * @param {Object} state
 * @param {Object} relatedProduct
 */
const SET_APP_PRODUCT_REVIEWS = (state, product) => {
  product.reviews ? (state.appProduct.productReviews = product.reviews) : [];
  product.reviews_average ? (state.appProduct.productReviewsAverage = product.reviews_average) : {};
};

const SET_APP_PRODUCT_PRICE_INFO = (state, product) => {
  product.price_info ? (state.appProduct.priceInfo = product.price_info) : [];
};

const SET_APP_PRODUCT_CAN_ADD_TO_COMPARATOR = (state, product) => {
  product.can_add_to_comparator
    ? (state.appProduct.canAddToComparator = product.can_add_to_comparator)
    : true;
};

// --- TVA
/**
 *
 * @param {Object} state
 * @param {Number} particularTva
 */
const SET_APP_PRODUCT_PARTICULAR_TVA = (state, particularTva) => {
  if (particularTva !== 0) {
    state.appProduct.billInfo.tva = particularTva;
  }
};
const SET_APP_PRODUCT_ORIGINAL_TVA = state => {
  const billInfo = state.appProduct.billInfo;
  if (billInfo.tva && billInfo.originalTva) {
    billInfo.tva = billInfo.originalTva;
  }
};

// ---- IS CAN BE REDUCED  ---
/**
 *
 * @param {Object} state
 * @param {Boolean} isCanBeReduced
 */
const SET_APP_PRODUCT_SHIPPING_IS_TAX_REDUCIBLE = (state, isTaxReducible) => {
  typeof isTaxReducible !== "undefined"
    ? (state.appProduct.isTaxReducible = isTaxReducible)
    : false;
};

// ---- PUSH COM  ---
const SET_APP_PRODUCT_PUSH_COM = (state, product) => {
  if (product.mcp_push_com) {
    state.appProduct.pushCom = product.mcp_push_com;
    state.appProduct.pushComUrl = product.mcp_push_com_url;
  }
}

const SET_APP_PRODUCT_CATEGORY_ID = (state, product) => {
  product.mcp_main_category_id ? (state.appProduct.getCategoryId = product.mcp_main_category_id) : false;
};

const SET_CONFIG_QUESTIONS = (state, questions) => {
  let appProduct = state.appProduct;
  appProduct.configQuestions = questions;
}

const SET_APP_PRODUCT_AVAILABLE_FOR_RENTING = (state, product) => {
  product.is_rentable ? (state.is_rentable = product.is_rentable) : [];
};

const SET_APP_PRODUCT_AVAILABLE_FOR_FINANCING = (state, product) => {
  product.is_financeable ? (state.is_financeable = product.is_financeable) : [];
};

const SET_APP_PRODUCT_RETAILABLE = (state, product) => {
  product.is_retailable ? (state.is_retailable = product.is_retailable) : [];
};

const SET_APP_PRODUCT_RENTING_PRICE = (state, product) => {
  product.renting_price ? (state.renting_price = product.renting_price) : [];
};
const SET_APP_PRODUCT_FINANCING_PRICE = (state, product) => {
  product.financing_price ? (state.financing_price = product.financing_price) : [];
};

const SET_APP_PRODUCT_EXTENDED_WARRANTY = (state, product) => {
  product.mcp_extended_warranty ? (state.mcp_extended_warranty = product.mcp_extended_warranty) : [];
};

const SET_APP_PRODUCT_ADDITIONAL_PRODUCT = (state, product) => {
  product.additional_product ? (state.additional_product = product.additional_product) : [];
};

const SET_SELECTED_MONTH_RENTING = (state, selectedMonthsRenting) => {
  typeof selectedMonthsRenting !== "undefined" ? (state.months_renting = selectedMonthsRenting) : 0;
};

const SET_APP_PRODUCT_RENTING_RELATED_PRODUCTS = (state, product) => {
  product.related_products.renting_related_product ? (state.appProduct.renting_related_products = product.related_products.renting_related_product) : [];
};

const SET_APP_PRODUCT_RATE_TAX_DELIVERY_CLASSIC = (state, rateTaxDeliveryClassic) => {
  typeof rateTaxDeliveryClassic !== "undefined" ? (state.rate_tax_delivery_classic = rateTaxDeliveryClassic) : 5.5;
};

const SET_APP_PRODUCT_IS_LEAD = (state, product) => {
  product.mcp_fp_mode_lead ? (state.is_lead = product.mcp_fp_mode_lead) : false;
};

const SET_APP_PRODUCT_IS_PAC = (state, product) => {
  product.pac_type ? (state.is_pac = true) : false;
};

const SET_PAC_TYPE = (state, product) => {
  product.pac_type ? (state.pac_type = product.pac_type) : state.pac_type = null;
}

const SET_SHARE_LINK_URL = (state, product) => {
  if(product.social_share_urls_encoded) {
    Object.keys(product.social_share_urls_encoded).map((key) => {
      state.appProduct.socialMediaShare.push({
        media: key,
        infos: product.social_share_urls_encoded[key],
      })
    })
  }
};
// Get different tva profil
const SET_TVA_PROFILS = (state, profils) => {
  let tvaProfils = [];

  Object.keys(profils).forEach(key => {
    if(key !== "ht") tvaProfils.push(parseFloat(key))
  })
  tvaProfils.sort((a,b) => a - b)

  state.tva_profils.low_rate = tvaProfils[0];
  state.tva_profils.medium_rate = tvaProfils[1];
  state.tva_profils.high_rate = tvaProfils[2];
}

const SET_LEAD_TYPE = (state, product) => {
  state.appProduct.lead_type = product.lead_type;
}

/**
 * @param {Object} state
 * @param {String} universe
 */
const SET_MCP_UNIVERSE = (state, universe) => {
  state.mcp_universe = universe;
}

/**
 * @param {Object} state
 * @param {Object} product
 */
const SET_ACCESSORY_PRODUCT = (state, product) => {
  state.is_accessory_product = product.is_accessory_product;
}

const SET_IS_RFID_CARD = (state, product) => {
    product.sku == "WEBKIT RFID ZEBORNE MOBILTY SERVICES" ? state.is_RFID_card = true : state.is_RFID_card = false;
}

/**
 * @param {Object} state
 * @param {Object} product
 */
const SET_BREADCRUMBS = (state, product) => {
    product.breadcrumbs.forEach(crumb => {
        state.breadcrumbs.push(crumb)
    })
}

/**
 * @param {Object} state
 * @param {Object} product
 */
const SET_SLOTS_CHOICE_ACTIVE = (state, product) => {
  state.mcp_slots_choice_active = product.mcp_slots_choice_active;
}

/**
 * @param {Object} state
 * @param {Object} product
 */
const SET_APP_PRODUCT_FORM_STRAPI_ID = (state, product) => {
  state.mcp_form_strapi_id = product.mcp_form_strapi_id;
}

export default {
  SET_APP_PRODUCT_ID,
  SET_APP_PRODUCT_IS_IN_COMPARATOR,
  SET_APP_PRODUCT_GLOBALS,
  SET_APP_PRODUCT_DESCRIPTIONS,
  SET_APP_PRODUCT_THUMBNAIL,
  SET_APP_PRODUCT_LEGEND,
  SET_APP_PRODUCT_GALLERY,
  SET_APP_PRODUCT_VIDEO,
  SET_APP_PRODUCT_SHIPPING_METHODS,
  SET_APP_PRODUCT_OPTIONS,
  SET_APP_PRODUCT_NOTICE,
  SET_APP_PRODUCT_FLASH_SELL,
  SET_APP_PRODUCT_SHIPPING_INFO,
  SET_APP_PRODUCT_RELATED,
  SET_APP_PRODUCT_CAN_ADD_TO_COMPARATOR,
  SET_APP_PRODUCT_BILL_INFO,
  SET_APP_PRODUCT_REDUCED_TAX_RATE,
  SET_APP_PRODUCT_PARTICULAR_TVA,
  SET_APP_PRODUCT_ORIGINAL_TVA,
  SET_APP_PRODUCT_SHIPPING_IS_TAX_REDUCIBLE,
  SET_APP_PRODUCT_ID_FROM_CART,
  SET_APP_PRODUCT_REVIEWS,
  SET_APP_PRODUCT_PRICE_INFO,
  SET_APP_PRODUCT_CART_URL,
  SET_APP_PRODUCT_PUSH_COM,
  SET_APP_PRODUCT_CATEGORY_ID,
  SET_CONFIG_QUESTIONS,
  SET_APP_PRODUCT_AVAILABLE_FOR_RENTING,
  SET_APP_PRODUCT_AVAILABLE_FOR_FINANCING,
  SET_APP_PRODUCT_RETAILABLE,
  SET_APP_PRODUCT_EXTENDED_WARRANTY,
  SET_APP_PRODUCT_RENTING_PRICE,
  SET_APP_PRODUCT_FINANCING_PRICE,
  SET_APP_PRODUCT_ADDITIONAL_PRODUCT,
  SET_APP_PRODUCT_ESSENTIALS_OPTIONS,
  SET_SELECTED_MONTH_RENTING,
  SET_APP_PRODUCT_RENTING_RELATED_PRODUCTS,
  SET_APP_PRODUCT_RATE_TAX_DELIVERY_CLASSIC,
  SET_APP_PRODUCT_IS_LEAD,
  SET_APP_PRODUCT_IS_PAC,
  SET_SHARE_LINK_URL,
  SET_TVA_PROFILS,
  SET_LEAD_TYPE,
  SET_MCP_UNIVERSE,
  SET_ACCESSORY_PRODUCT,
  SET_IS_RFID_CARD,
  SET_BREADCRUMBS,
  SET_APP_PRODUCT_SHIPPING_METHOD_SPECIAL_PRICE,
  SET_SLOTS_CHOICE_ACTIVE,
  SET_APP_PRODUCT_FORM_STRAPI_ID,
  SET_PAC_TYPE
};
